var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.col-md[data-v-4b9284f3] {\n    margin-right: 0%;\n}\n@media (max-width: 768px) {\n.search[data-v-4b9284f3] {\n    margin-top: 42px;\n}\n.toolbarPageBottomBlank[data-v-4b9284f3] {\n    height: 175px !important;\n}\n}\n@media (min-width: 768px) and (max-width: 996px) {\n.search[data-v-4b9284f3] {\n    margin-top: 35px;\n}\n}\n.rowBackgroundImage[data-v-4b9284f3] {\n  background-image: url(" + escape(require("../../assets/static/images/MenuFont.png")) + ");\n  background-size: contain;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b9284f3","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/attachments/CMAttachmentsPage.vue
// module id = 1133
// module chunks = 2